<template>
  <article id="policy-details-insured-item" data-test-policy-insured-item>
    <h2>{{ value.LabelInsuredItemHeadline }}</h2>

    <field v-model="value.InsuredPersonName" name="insured-person-name" />

    <field v-model="value.SocialSecurityNumber" name="social-security-number" />

    <field
      v-if="value.ShowPermanentInjury"
      v-model="value.PermanentInjury"
      name="permanent-injury"
    />

    <field v-if="value.ShowScopeOfCover" v-model="value.ScopeOfCover" name="scope-of-cover" />

    <field v-if="value.ShowSelfEmployed" v-model="value.SelfEmployed" name="selfemployed" />

    <field v-if="value.ShowProfession" v-model="value.Profession" name="profession" />

    <field v-if="value.ShowSideProfession" v-model="value.SideProfession" name="side-profession" />

    <field v-if="value.ShowZipCode" v-model="value.ZipCode" name="zipcode" />
  </article>
</template>

<script>
import Field from '../Field.vue';

export default {
  name: 'PersonalAccident',
  components: {
    Field
  },
  props: {
    value: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
